import request from '@/utils/request'

export function getmerchlist(data) {
  return request({
    url: 'get/merchs',
    method: 'post',
    params: data
  })
}

export function getmerchpayinfos(data) {
  return request({
    url: 'get/merch/payinfos',
    method: 'post',
    params: data
  })
}

export function getMerchPayInfosDownload(data) {
  return request({
    url: 'get/merch/payinfos/download',
    method: 'post',
    params: data
  })
}

export function configMerchPaymentChanel(data) {
  return request({
    url: 'config/merch/payment/chanel',
    method: 'post',
    params: data
  })
}

export function declineMerchPayInfos(data) {
  return request({
    url: 'decline/merch/payinfos',
    method: 'post',
    params: data
  })
}

export function getMerchPayinfoById(data) {
  return request({
    url: 'get/merch/payinfo/byid',
    method: 'post',
    params: data
  })
}

export function getmerchbyid(data) {
  return request({
    url:'get/merch/info/byid',
    method:'post',
    params: data
  })
}

export function activateUpay(data){
  return request({
    url:'upay/activate/terminal',
    method:'post',
    params: data
  })
}

export function getUpayActivatedInfo(data){
  return request({
    url:'upay/get/activate/info',
    method:'post',
    params: data
  })
}

